module.exports = "../../../../platform/assets/pageMainIcon/cd-org-business-unit.svg";